const CryptoJSData = {
  publicKey:
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDd0bG9YcCsOUo/46jm27eMU29LYwl0kXoaB3YigO6eQpel4B7gMnSUDkKYRKfMFImQPZnZ/CZHwVpYZk08QzcuqGY6CijFJH2ZHG+Kji45wa85Urg+9Qc45HGmoalbWBoiLZCP3PYQvDmgN5Kl+p4aUy9woi7w0GwFOr0lpb4nQQIDAQAB", // RSA公钥
  appid: "20240731164944",
  deviceid: "127.321664-61561_chsshtml"
};
export default {
  CryptoJSData
};
